<div>{{ "global.common.primary_contact" | translate }}</div>
<nz-form-control>
	<nz-select
		[nzDropdownStyle]="dropDownStyle"
		[nzSize]="'large'"
		(ngModelChange)="selectPrimaryContact($event)"
		[(ngModel)]="primaryContact"
	>
		<nz-option
			*ngFor="let user of users"
			[nzValue]="user['id']"
			[nzLabel]="user['email']"
		>
		</nz-option>
	</nz-select>
</nz-form-control>
